module.exports = __webpack_public_path__ + "zimbabwe.svg?e56750e079ddaf189bd839f0589fde92";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/zimbabwe.svg
// module id = 344
// module chunks = 10